import HomePage from '@system/config/home-page';
import React from 'react'
import { useSearchParams } from 'react-router-dom';
import System from 'src/helper/system';
import useReduxState from 'src/hooks/useReduxState';
import CommonContent from './CommonContent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';

let c = System.getParams();
const HomePageContentTabsListing = (props) => {
    const homeContentTabType = System.getParams().__c_HomePageContentTabList;
    const [selectedTab, setSelectedTab] = useReduxState('ALCT', 'searchContentTabParams')
    const [searchParams] = useSearchParams();
    const [HomePageContentTabList__Component__Loader, Set_HomePageContentTabList__Component__Loader] = useReduxState(searchParams.get(CommonContent.param_key_HomePageContentTabList) ? searchParams.get(CommonContent.param_key_HomePageContentTabList) : CommonContent.default_component.param_value, CommonContent.redux_key_HomePageContentTabList);
    const [selectedFilterList, setSelectedFilterList] = useReduxState([], 'selectedContentFilterList');
    const [filterFacets, setFilterFacets] = useReduxState([], 'setContentFilterFacets');
    const [__check] = useAxiosIndicatorCheck();
    const getActiveClass = (singleElement) => {
        if (CommonContent.chain_HomePageContentTabList[HomePageContentTabList__Component__Loader].param_value === singleElement.param_value) {
            return 'active'
        }
        return ''
    };

    const getTabLink = (singleElement) => {
        return HomePage.getHomeContentTabsListRouteURL({
            ...c,
            [CommonContent.param_key_HomePageContentTabList]: singleElement.param_value
        });
    };
    const switchTab = async (url, chain_single) => {
        setSelectedFilterList([])
        setFilterFacets([])
        history.pushState('', '', url);
        Set_HomePageContentTabList__Component__Loader(chain_single.param_value);
    };

    React.useEffect(() => {
        async function fetchHere() {
            setSelectedTab(homeContentTabType !== undefined ? homeContentTabType : 'ALCT')
        }

        fetchHere()
    }, [homeContentTabType]);

    return (
        <>
            <div className="all-content-tabs">
                <ul className="nav nav-tabs">
                    {Object.entries(CommonContent.chain_HomePageContentTabList).map((v) => (
                        <React.Fragment key={v[1].name}>
                            <li className={v[1].store().count === 0 ? 'bs5 nav-item disabled' : 'bs5 nav-item ' + getActiveClass(v[1])} key={v[1].name}>
                                <a className={'count hidden-xs hidden-sm'}
                                    href={void (0)}
                                    onClick={async (e) => {
                                        v[1].store().count > 0 ?
                                            await switchTab(getTabLink(v[1]), v[1]) : e.preventDefault()
                                    }}
                                >
                                    {v[1].name}
                                    <span className="count hidden-xs hidden-sm"> ({v[1].store().count})</span>
                                    <span className="count-bubble hidden-md hidden-lg"> {v[1].store().count}</span>
                                </a>
                            </li>
                        </React.Fragment>
                    ))
                    }
                </ul>
            </div>
            <div className="search-page-tab mobile-tab">
                {__check(['ALL_CONTENT_COUNT_API_CALL']).status ? <AxiosIndicatorRunTimeLoader /> :
                  <div
                    id={CommonContent.chain_HomePageContentTabList[HomePageContentTabList__Component__Loader].param_value}
                    className="active">
                      {React.createElement(CommonContent.chain_HomePageContentTabList[HomePageContentTabList__Component__Loader].element, props)}
                  </div>}
            </div>
        </>
    )
}

export default HomePageContentTabsListing